import { render } from "./quotemensaje_ingles.vue?vue&type=template&id=08c50a35&scoped=true"
import script from "./quotemensaje_ingles.vue?vue&type=script&lang=js"
export * from "./quotemensaje_ingles.vue?vue&type=script&lang=js"

import "./quotemensaje_ingles.vue?vue&type=style&index=0&id=08c50a35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c50a35"]])

export default __exports__